﻿import {
  appendQueryParameters,
  fetchBaseQueryWrapper,
  NO_CACHING,
} from "@/services/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";

export const dashboardApi = createApi({
  reducerPath: "dashboardApi",
  baseQuery: fetchBaseQueryWrapper({
    path: "dashboard",
  }),
  keepUnusedDataFor: NO_CACHING,
  endpoints: (build) => ({
    getPendingApprovals: build.query({
      query: (queryParams) =>
        appendQueryParameters("pending-intake-approval", queryParams),
    }),
    getPendingMilestoneApprovals: build.query({
      query: (queryParams) =>
        appendQueryParameters("pending-milestone-approvals", queryParams),
    }),
    getRoutingMilestoneApprovals: build.query({
      query: (queryParams) =>
        appendQueryParameters("routing-milestone-approvals", queryParams),
    }),
    getRecentlyApprovedIntakes: build.query({
      query: (queryParams) =>
        appendQueryParameters("recently-approved-intakes", queryParams),
    }),
    getRecentlyApprovedMilestones: build.query({
      query: (queryParams) =>
        appendQueryParameters("recently-approved-milestones", queryParams),
    }),
    getKeyMilestoneDashboard: build.query({
      query: () => "key-milestones",
    }),
  }),
});

export const {
  useGetPendingApprovalsQuery,
  useGetPendingMilestoneApprovalsQuery,
  useGetRoutingMilestoneApprovalsQuery,
  useGetRecentlyApprovedIntakesQuery,
  useGetRecentlyApprovedMilestonesQuery,
  useGetKeyMilestoneDashboardQuery,
} = dashboardApi;
